<ng-select
  [items]="availableFilters"
  placeholder="Search..."
  [(ngModel)]="selectedFilters"
  (change)="actOnSelection($event)"
  (clear)="actOnSelection($event)"
  [multiple]="true"
  [virtualScroll]="true"
  bindLabel="name"
  bindValue="id"
></ng-select>
